module.exports = __webpack_public_path__ + "img/money_kinri_agaru.e8304891.png";